import React, { memo, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { LatexComponent } from '../..';
import { getMedia, typeTemplate } from '../../common';
import { FileObject } from 'models/test-attack-file.model';
import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
}

function displayAttachment(attackFile: FileObject) { 
  if (attackFile.type.startsWith('image/')) {
      return <img src={attackFile.url} alt={attackFile.name} className="w-100" />;
  }
  if (attackFile.type.startsWith('video/')) {
      return <video controls className="w-100"><source src={attackFile.url} type="video/mp4" /></video>;
  }
  if (attackFile.type.startsWith('audio/')) {
      return <audio controls className="w-100"><source src={attackFile.url} type="audio/mpeg" /></audio>;
  }
  if (attackFile.type === 'application/pdf') {
    return (
      <iframe
        src={attackFile.url}
        className="w-100 border-none"
        style={{ height: 'calc(100vh - 120px)' }}
        title={attackFile.name}
      />
    );
  }

  if (
    attackFile.type === 'application/msword' || // .doc
    attackFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
    attackFile.type === 'application/vnd.ms-excel' || // .xls
    attackFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
  ) {
    return (
      <iframe
        src={`https://docs.google.com/gview?url=${encodeURIComponent(attackFile.url)}&embedded=true`}
        className="w-100 border-none"
        style={{ height: 'calc(100vh - 120px)' }}
        title={attackFile.name}
      />
    );
  }
  return <div>{attackFile.name}</div>;
}

const TCHTieuLuanComponent: React.FC<PropTypes> = ({ question }) => {
  const [visible, setVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState<FileObject>(new FileObject());
  const [selectedRows, setSelectedRows] = useState<FileObject[]>([]);

  let attachedFiles: FileObject[] = [];
  if (question.answer && question.answer.length) {
    try {
      attachedFiles = JSON.parse(question.answer);
    } catch (err) {
      console.error('Invalid JSON in question.answer', err);
    }
  }

  return (
    <div>
      <label>Bài làm</label>
      <div className="tieu-luan">
        <LatexComponent>
          <div
            dangerouslySetInnerHTML={{
              __html: question.userAnswer || '',
            }}
          />
        </LatexComponent>
      </div>

      <div className="mt-3">Tệp đính kèm</div>
      <div className="attack-file">
        {attachedFiles.length > 0 ? (
          <DataTable
            value={attachedFiles.filter(f => !f.isDelete)}
            dataKey="id"
            scrollable
            selectionMode="checkbox"
            selection={selectedRows}
            onSelectionChange={(e) => setSelectedRows(e.value)}
          >
            <Column field="type" header="Loại" body={typeTemplate} style={{ width: '100px' }} />
            <Column
              field="name"
              header="Tên"
              body={(file: FileObject) => (
                <span
                  className="pointer text-blue-400"
                  title="Click vào đây để xem nội dung tệp đính kèm"
                  onClick={() => {
                    setVisible(true);
                    setSelectedFile(file);
                  }}
                >
                  {file.name}{' '}
                  {file.isNew ? (
                    <i className="text-orange-400 pi pi-sun" title="File mới được thêm, chưa lưu lại" />
                  ) : (
                    <i className="pi pi-cloud text-green-400" title="File đã lưu rồi" />
                  )}
                </span>
              )}
              style={{ width: 'calc(100% - 250px)' }}
            />
            <Column field="size" header="Kích thước" style={{ width: '150px' }} />
          </DataTable>
        ) : (
          <span>Không có file đính kèm</span>
        )}
      </div>

      <Sidebar
        visible={visible}
        fullScreen={true}
        className="w-1000px"
        position="right"
        onHide={() => setVisible(false)}
      >
        <div className="header-title">Nội dung file đính kèm {selectedFile.name}</div>
        {visible && <div style={{ height: 'calc(100vh - 50px)' }}>{displayAttachment(selectedFile)}</div>}
      </Sidebar>
    </div>
  );
};

export default memo(TCHTieuLuanComponent);
